import axios from 'axios'
// import {
//   Toast,
//   Dialog
// } from '@vant/compat'
import 'vant/es/toast/style';
import { showToast } from 'vant';
// import 'vant/es/toast/style'
import {getToken, setToken} from "@/utils/auth";
import Cookies from "js-cookie";
import store from "@/store";
import router, {resetRouter} from '@/router';

// create an axios instance
const { CancelToken } = axios
const source = CancelToken.source()
const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API, // url = base url + request url
  withCredentials: true, // send cookies when cross-domain requests
  timeout: 15000 // request timeout
})

// request interceptor
service.interceptors.request.use(
  (config) => {
    const token = getToken()
    // if (token) {
    //   config.headers.Authorization = getToken()
    //   config.cancelToken = source.token
    // }
    if (token) {
      // let each request carry token
      // ['X-Token'] is a custom headers key
      // please modify it according to the actual situation
      config.headers.Authorization = getToken() || ''
      config.headers['auth-token'] = getToken() || ''
      config.cancelToken = source.token
    }
    return config
  },
  (error) => {
    // do something with request error
    console.log(error) // for debug
    return Promise.reject(error)
  }
)

// response interceptor
service.interceptors.response.use(
  /**
   * If you want to get http information such as headers or status
   * Please return  response => response
   */

  /**
   * Determine the request status by custom code
   * Here is just an example
   * You can also judge the status by HTTP Status Code
   */
  (response) => {
    if (!Cookies.get('governance_token') || Cookies.get('governance_token') === 'undefined') {
      Cookies.set('governance_token', response.headers['auth-token'])
    }
    const res = response.data

    // if the custom code is not 20000, it is judged as an error.
    if (res.code !== 200) {
      console.log(res)
      // Message({
      //   message: res.message || 'Error',
      //   type: 'error',
      //   duration: 5 * 1000
      // })
      showToast({
       message: res.message|| 'Error',
       type:'fail'
      })

      // 50008: Illegal token; 50012: Other clients logged in; 50014: Token expired;
      if (res.code === 20 || res.code === 405 || res.code === 333 || res.code === 401) {
        showToast({
          message: res.msg || 'Error',
          icon: 'none',
          duration: 3 * 1000
        })
        store.dispatch('user/resetToken').then(() => {
          resetRouter()
          router.push(`/login`)
        })
      } else if (res.code === 12021 || res.code === 12023) {
        return res
      }
      else {
        showToast({
          message: res.msg || 'Error',
          icon: 'none',
          duration: 3 * 1000
        })
      }
      return Promise.reject(new Error(res.msg || 'Error'))
    }
    return res
  },
  (error) => {
    console.log(`err${error}`) // for debug
    // Message({
    //   message: error.message,
    //   type: 'error',
    //   duration: 5 * 1000
    // })
    showToast({
      message: error.message,
      icon: 'none',
      duration: 3 * 1000
    })
    return Promise.reject(error)
  }
)

export default service
